import { useMemo } from 'react';
import { useAllCustomers } from './useAllCustomers';

export const useHasAnyValidCustomer = (options?: { includeIntermodalCustomers?: boolean }) => {
  const customers = useAllCustomers();

  return useMemo(
    () => customers.some(c => !options?.includeIntermodalCustomers || c.isIntermodal),
    [customers, options?.includeIntermodalCustomers],
  );
};
